// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CloseAccountResponseStatus } from '../Enums/Constants';
import { DirectMessageBaseClass as DirectMessageBase } from './DirectMessageBase';
import { Message } from './Message';
export class DirectCloseAccountResponseMessage extends DirectMessageBase {
    constructor() {
        super(Message.CODE_PFIX_CLOSE_ACCOUNT_RESPONSE_MESSAGE);
        this._status = CloseAccountResponseStatus.New;
        this._closeAccountRequestID = -1;
    }
    get status() {
        return this._status;
    }
    set status(newStatus) {
        this._status = newStatus;
    }
    get closeAccountRequestID() {
        return this._closeAccountRequestID;
    }
    set closeAccountRequestID(newValue) {
        this._closeAccountRequestID = newValue;
    }
}
